import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { FilterDTO } from '@tempo-io/roadmap-dto';
import { ItemsApi } from '@/common/api/items';
import type { ItemFiltersType } from '@/common/api/types/itemFilters';
import type { Item, ItemRequestModelField } from '@/common/api/types/items';
import { commonQueryKeys } from '@/common/queryKeys/common';
import { viewQueryKeys } from '@/features/views/queryKeys';

export const useItemsBulkFetchQuery = (
  {
    itemIds,
    fields,
    filter,
    viewId,
  }: {
    itemIds: number[];
    fields?: ItemRequestModelField[];
    filter?: ItemFiltersType;
    viewId?: number;
  },
  staleTime?: number,
  enabled = true,
) => {
  const queryClient = useQueryClient();

  const cachedFilters = viewId
    ? (queryClient.getQueryData<FilterDTO[]>(viewQueryKeys.filter.list(viewId)) ?? [])
    : [];

  const filtersLoaded = !filter || cachedFilters.length > 0;
  return useQuery<Item[]>({
    queryKey: [
      ...commonQueryKeys.itemsBulkFetch.byParams({ ids: itemIds, fields, filter }),
      ...(viewId ? [viewQueryKeys.filter.list(viewId)] : []),
    ],
    queryFn: () => ItemsApi.getItemsBulkFetchChunked({ ids: itemIds, fields, filter }),
    enabled: enabled && filtersLoaded,
    ...(staleTime !== undefined && { staleTime }),
    refetchOnMount: false,
    placeholderData: (previousData) => previousData,
  });
};
